import { Injectable } from '@angular/core';
import { Router, CanActivate, UrlTree } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { CognitoService } from '../services/cognito.service';
import { AuthService } from '../services/auth.service';
import { RefreshToken } from '../models/refresh-token';

@Injectable({
  providedIn: 'root'
})
export class CheckTokenGuard implements CanActivate {
  constructor(public router: Router, public cognitoService: CognitoService, public authService: AuthService) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem("Authorization");

    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expired = this.isExpired(payload.exp);

        return this.verifyRefresh(expired, token);
      } catch (error) {
        console.error('Error al decodificar el token:', error);
        this.clearSession();
        return false;
      }
    } else {
      return true;
    }
  }

  async verifyRefresh(expired: boolean, token: string): Promise<boolean> {
    if (expired) {
      try {
        const { username, userId, signInDetails } = await this.cognitoService.currentAuthenticatedUser();
        const newToken = await this.cognitoService.returnAccesToken() as string;

        if (newToken) {
          localStorage.setItem("Authorization", newToken);

          const refreshToken: RefreshToken = {
            username: signInDetails?.loginId!,
            oldToken: token,
            newToken: String(newToken)
          };

          this.authService.refreshToken(refreshToken).subscribe(response => {
            console.log('Token actualizado:', response);
          });

          return true;
        } else {
          this.clearSession();
          return false;
        }
      } catch (error) {
        console.error('Error al refrescar el token:', error);
        this.clearSession();
        return false;
      }
    } else {
      return true;
    }
  }

  isExpired(expiration: number): boolean {
    return expiration < Math.floor(Date.now() / 1000);
  }

  private clearSession(): void {
    console.warn("Token inválido o expirado. Cerrando sesión...");
    localStorage.clear();
    this.router.navigateByUrl("/account-login");
  }

}
